import * as React from 'react';
import history from "../history";
import {ConnectedRouter} from "react-router-redux";
import {Route, Switch} from "react-router-dom";
import {ROUTE_KFZ, ROUTE_KFZ_CREATE, ROUTE_KFZ_EDIT, ROUTE_KFZ_MODEL, ROUTE_KFZ_MODEL_CREATE} from "./index";
import KfzListController from "../containers/KfzListController";
import KfzCreateController from "../containers/KfzCreateController";
import KfzEditController from "../containers/KfzEditController";
import KfzModelCreateController from "../containers/KfzModelCreateController";
import KfzModelEditController from "../containers/KfzModelEditController";

export default () => (
	<ConnectedRouter history={history}>
		<Switch>
			<Route exact path={ROUTE_KFZ} component={KfzListController}/>
			<Route exact path={ROUTE_KFZ_CREATE} component={KfzCreateController}/>
			<Route exact path={ROUTE_KFZ_EDIT} component={KfzEditController}/>
			<Route exact path={ROUTE_KFZ_MODEL_CREATE} component={KfzModelCreateController}/>
			<Route exact path={ROUTE_KFZ_MODEL} component={KfzModelEditController}/>
			{/*<Route exact path={ROUTE_KFZ_MODEL} component={KfzEditController}/>*/}
			{/*<Route path={ROUTE_MODULES_CREATE} component={ModuleCreateController}/>*/}
			{/*<Route path={ROUTE_MODULES_DETAIL} component={() => <div>Module detail</div>}/>*/}
		</Switch>
	</ConnectedRouter>
);


// WEBPACK FOOTER //
// ./src/routes/KfzRoutes.js